export default __webpack_public_path__ + "static/media/DownloadIcon.b7a5b0e9.svg";